import React, { useState } from 'react';
// @ts-ignore
import styles from './EventsList.module.scss';
import LinkButton from '../Button/LinkButton';
import apiClient from '../../Services/ApiClient';
import { EVENTS_QUERY } from '../../Modules/Events/Graphql/events.graphql';
// @ts-ignore
import moment, { Moment } from 'moment';
import { useEffectAsync } from '../../helpers';
import { Theme } from '../../Enums/Theme.enum';
import NoDataPlaceholder from '../Placeholder/NoDataPlaceholder';
import Text from '../Base/Text/Text';
import { EventType } from '../../Modules/Event/Enums/EventType.enum';
import { MetaKey } from '../../Modules/Meta/Enums/MetaKey.enum';
import { useAppContext } from '../../Services/AppContext';

interface EventsListProps {
	patientId: string;
	workplaceId: string;
	onShowInCalendar?: any;
}

interface Event {
	id: string;
	title: string;
	dateFrom: Moment | string;
	note?: string;
	meetingType: EventType;
	doctorName: string;
	workplaceName: string;
}

export default function EventsList(props: EventsListProps) {
	const { patientId, workplaceId, onShowInCalendar } = props;
	const [events, setEvents] = useState<Event[]>([]);
	const { dateFormatMoment } = useAppContext();

	const handleShowInCalendar = (id: string) => {
		onShowInCalendar &&
			onShowInCalendar('order', { params: { eventId: id } }, 'order');
	};

	// @ts-ignore
	useEffectAsync(async () => {
		const tempEvents: Event[] = [];
		const variables = {
			start: new Date().toISOString(),
			types: ['DEFAULT'],
			workplaceIds: [workplaceId],
			userIds: [patientId],
		};

		const { data } = await apiClient.graphql({
			query: EVENTS_QUERY,
			variables,
			fetchPolicy: 'network-only',
		});

		for (const event of data.events.data) {
			tempEvents.push({
				id: event.id,
				title: event.title,
				dateFrom: moment(event.dateFrom).format(),
				note: event.description,
				meetingType: event?.meta?.find(
					({ key }: any) => key === MetaKey.MEETING_TYPE,
				)?.value,
				doctorName: event?.eventMembers?.find(
					({ user }: any) => user.isDoctor === true,
				)?.user?.profile?.fullName,
				workplaceName: event?.calendar?.workplace?.doctorDisplayName,
			});
		}
		setEvents(tempEvents);
	}, []);

	return (
		<div className={styles.wrapper}>
			{events.length > 0 ? (
				<>
					<div className={styles.header}>
						<Text
							className={styles.date}
							tx='component.eventList.header.date'
						/>
						<Text
							className={styles.typeOfConsultation}
							tx='component.eventList.header.typeOfConsultation'
						/>
						<Text
							className={styles.doctor}
							tx='component.eventList.header.doctor'
						/>
						<Text
							className={styles.caseType}
							tx='component.eventList.header.caseType'
						/>
					</div>
					<div className={styles.list}>
						{events.map((item: Event, index) => {
							return (
								<div className={styles.item} key={index}>
									<div className={styles.date}>
										{moment(item.dateFrom).format(dateFormatMoment + ' HH:mm')}
									</div>
									<div className={styles.meetingType}>
										{[EventType.ON_SITE, EventType.TELEMEDICINE].includes(
											item.meetingType,
										) && (
											<Text
												tx={`base.meetingType.${item.meetingType}`}
												inline
											/>
										)}
									</div>
									<div className={styles.doctor}>
										<div className={styles.name}>{item.doctorName}</div>
										<div className={styles.workplace}>{item.workplaceName}</div>
									</div>
									<div className={styles.content}>
										<div className={styles.title}>{item.title}</div>
										<div className={styles.note}>{item.note}</div>
									</div>
									<div className={styles.controls}>
										<LinkButton
											onClick={() => handleShowInCalendar(item.id)}
											title={'base.showInCalendar'}
											theme={Theme.BLUE}
										/>
									</div>
								</div>
							);
						})}
					</div>
				</>
			) : (
				<NoDataPlaceholder tx={'base.patientIsNotOrderedToDoctor'} />
			)}
		</div>
	);
}
